module.exports = __webpack_public_path__ + "static/media/05.a639a54a.png";